import { InjectionToken } from '@angular/core';
import { HttpInterceptor } from '@angular/common/http';

export const TOTARA_HTTP_INTERCEPTORS = new InjectionToken<HttpInterceptor[]>('TOTARA_HTTP_INTERCEPTORS');
